<template>
  <modal name="notice-dialog" :adaptive="true" :scrollable="true" height="auto">
    <div
      class="v--modal-close-top"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <el-button
        @click="closeNoticeDialog"
        icon="el-icon-circle-close"
        style="font-size: 2rem"
        type="text"
      ></el-button>
    </div>
    <div class="news_popup">
      <h3 class="n_h3">リリース情報</h3>
      <div class="n_contents">
        <p class="n_title">画像で伝える職務経歴書で自分をアピール</p>
        <p class="n_txt">
          職務経歴書に、文字だけでは伝わりづらいものでも、自分のプロジェクトや成果物を画像付きでアピールすることができます。
        </p>
        <button
          onclick="location.href = '/format/shokumukeirekisho_with_image'"
          class="n_button"
        >
          利用してみる
        </button>
      </div>
    </div>
  </modal>
</template>
<style scoped>
.news_popup .n_h3 {
  font-weight: bold;
  font-size: 16px;
  color: #004d40;
  margin-bottom: 10px;
  text-align: center;
}

.news_popup .n_contents {
  background: #eef5e8;
  padding: 15px;
  border-radius: 10px;
}

.news_popup .n_img {
  margin: 0 auto 10px;
}

.news_popup .n_title {
  font-weight: bold;
  margin-bottom: 5px;
}

.news_popup .n_txt {
  margin-bottom: 10px;
}

.news_popup .n_button {
  display: block;
  margin: 0 auto;
  background: #0f9934;
  color: #fff;
  width: 200px;
  padding: 10px 0;
  border-radius: 10px;
}
</style>
<script>
export default {
  components: {},
  data: function () {
    return {
      fullscreenLoading: false,
      dialogInfo: {}
    }
  },
  created: function () {},
  computed: {},
  methods: {
    openNoticeDialog: function (dialogInfo) {
      this.$modal.show('notice-dialog')
      this.dialogInfo = dialogInfo
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('open-notice-dialog', this.openNoticeDialog)
    this.$eventHub.$on('popstate', this.closeNoticeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('open-notice-dialog', this.openNoticeDialog)
    this.$eventHub.$off('popstate', this.closeNoticeDialog)
  }
}
</script>
